import * as React from "react";
import "./index.css";
import ModalBase from "../ModalBase";
import { CheckMarkCircle } from "../../icons";

const PaymentSuccessModal = ({ isOpen, onClose, receipt }) => {
  return (
    <ModalBase isOpen={isOpen} onClose={onClose} title={"Transaction Receipt"}>
      <div className="payment-success-container">
        <CheckMarkCircle className="payment-success-icon" />
        {/* <div className="payment-success-title">Payment Successful</div> */}
        <div className="payment-success-body">
          <span className="payment-success-body-text">
            {receipt
              ? "Thank you! your payment has been successfully processed, and your classified is being reviewed and will be posted within 24 hours."
              : "Thank you for submitting your classified! It is being reviewed and will be posted within 24 hours."}
          </span>
        </div>
        <div className="payment-success-footer">
          {receipt && (
            <a
              className="payment-success-footer-button"
              href={receipt.receipt_pdf}
            >
              Print Receipt
            </a>
          )}
          <div
            className="payment-success-footer-button outlined"
            onClick={onClose}
          >
            Close
          </div>
        </div>
      </div>
    </ModalBase>
  );
};

export default PaymentSuccessModal;
